import React from 'react';
export const Banner = () => {
  return <div className="w-full bg-[#042A1D] text-white overflow-hidden py-2" data-id="element-68">
      <div className="animate-marquee whitespace-nowrap" data-id="element-69">
        <span className="inline-block mx-4" data-id="element-70">ADVERTORIAL</span>
        <span className="inline-block mx-4" data-id="element-71">|</span>
        <span className="inline-block mx-4" data-id="element-72">
          TRENDING IN THE US{' '}
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/s6pRG9JjNcYPaKR7YTZzgQ/Flag_of_the_United_States.png" alt="American Flag" className="inline-block h-4 w-auto align-text-bottom" data-id="element-73" />
        </span>
        <span className="inline-block mx-4" data-id="element-74">ADVERTORIAL</span>
        <span className="inline-block mx-4" data-id="element-75">|</span>
        <span className="inline-block mx-4" data-id="element-76">
          TRENDING IN THE US{' '}
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/s6pRG9JjNcYPaKR7YTZzgQ/Flag_of_the_United_States.png" alt="American Flag" className="inline-block h-4 w-auto align-text-bottom" data-id="element-77" />
        </span>
        <span className="inline-block mx-4" data-id="element-78">ADVERTORIAL</span>
        <span className="inline-block mx-4" data-id="element-79">|</span>
        <span className="inline-block mx-4" data-id="element-80">
          TRENDING IN THE US{' '}
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/s6pRG9JjNcYPaKR7YTZzgQ/Flag_of_the_United_States.png" alt="American Flag" className="inline-block h-4 w-auto align-text-bottom" data-id="element-81" />
        </span>
        <span className="inline-block mx-4" data-id="element-82">ADVERTORIAL</span>
        <span className="inline-block mx-4" data-id="element-83">|</span>
        <span className="inline-block mx-4" data-id="element-84">
          TRENDING IN THE US{' '}
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/s6pRG9JjNcYPaKR7YTZzgQ/Flag_of_the_United_States.png" alt="American Flag" className="inline-block h-4 w-auto align-text-bottom" data-id="element-85" />
        </span>
      </div>
    </div>;
};